// extracted by mini-css-extract-plugin
export default {"rsbody":"RemoteSupportPage_rsbody__Pf2iT","rsBtnDiv":"RemoteSupportPage_rsBtnDiv__NTYhl","rsBtn":"RemoteSupportPage_rsBtn__NzFw5"};